
import { Link } from "react-router-dom";
import Slider from "react-slick";
import React from 'react';

export default function HomeProjectHighlights() {
  const services = [
    {
      img: "/assets/images/project-logistics1.webp",
      title: "Holiday Inn, New Delhi",
      link: "/project/holiday-inn-aerocity",
    },
    {
      img: "/assets/images/project-logistics2.webp",
      title: "Central Linen Park, Bhiwadi",
      link: "/project/central-linen-park",
    },
    {
      img: "/assets/images/project-logistics3.webp",
      title: "Medanta - The Medicity, Gurugram",
      link: "/project/medanta-the-medicity-gurugram",
    },
    {
      img: "/assets/images/project-logistics4.webp",
      title: "Lady Hardinge Hospital, New Delhi",
      link: "/project/lady-hardinge-hospital",
    },


  ];


  const settings = {
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    infinite: true,
    arrows: true,
    autoplaySpeed: 4000,
    speed: 5000,
    cssEase: "ease",
    prevArrow: (
      <button className="slick-arrow slick-prev" aria-label="Previous Slide">
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    ),
    nextArrow: (
      <button className="slick-arrow slick-next" aria-label="Next Slide">
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    ),
    responsive: [

      {
        breakpoint: 1029,
        settings: { slidesToShow: 3 },
      },

      {
        breakpoint: 991,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (

    <>

      <section className="service-section">
        <div className="container">
          <div className="row justify-content-center service-row">
            <div className="col-md-9 col-lg-7">
              <div className="heading-text">
                <h4 className="heading">Our Project Highlights</h4>
              </div>
            </div>
            <div className="col-md-3 col-lg-5">
              <div className="pro-desktop-btn">
                <div className="heading-btn">
                  <Link to="/project" className="default-btn"><span>View all</span></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="service-sec">
          <Slider {...settings} className="service-slider">
            {services.map((service, index) => (
              <div className="service-col" key={index}>
                <div className="service-inner">
                  <div className="image">
                    <img className="img-responsive" src={service.img} loading="lazy" alt={service.title} />
                  </div>
                  <div className="content">
                    <div className="title">{service.title}</div>
                    <Link to={service.link} className="start-here">
                      View Project
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>


        <div className="products-mobile-btn">
          <div className="heading-btn">
            <Link to="/project" className="default-btn"><span>View all</span></Link>
          </div>
        </div>
      </section>

    </>

  )
}



